module.exports = __webpack_public_path__ + "img/tmp-patients-status-5.bfe8d723.svg";